import React from 'react';
import { connect } from 'react-redux';
import { BaseDialog } from '../layout/Dialog';
import { showDialog } from '../../actions/dialog';
import './CsatModal.css';
import Logger from '../../util/Logger';
import { SHRUGGIE } from '../../constants';
import Event from '../../models/Event';
import DateTime from '../../models/DateTime';
import { eventApi } from '../../api/EventApi';
import { handleError } from '../../util/Errors';
import { CreatorReportAnalytics } from '../../analytics/CreatorReportAnalytics';
import _ from 'lodash';
import { TrackingAnalytics } from '../../analytics/TrackingAnalytics';

class CsatModal extends React.Component {

  whatQuestions = [
    'How effective was this POPin in achieving your goal?',
    'How easy was it to use POPin?'
  ];

  effectiveStarTitles = [
    'Not at all effective',
    'Not so effective',
    'Somewhat effective',
    'Very effective',
    'Extremely effective'
  ];

  easyStarTitles = [
    'Not at all easy',
    'Not so easy',
    'Somewhat easy',
    'Very easy',
    'Extremely easy'
  ];

  constructor (props) {
    super(props);

    if (!props.event) {
      Logger.assert('Need event for CSAT modal');
    }

    // Keep this '2' equal to the length of the whatQuestions array in getRandomQuestion()
    const index = Math.floor(Math.random() * (this.whatQuestions.length));
    this.state = {
      selectedStar: -1,
      currentlyHoveredStar: -1,
      csatComment: '',
      questionIndex: index,
      promptQuestion: this.getRandomQuestion(index),
      spin: false
    };
  }

  onDialogHidden = () => {
    const { onHidden } = this.props;
    onHidden();
  };

  getRandomQuestion = (index) => {
    return this.whatQuestions[index];
  };

  // selectedStar is 0 indexed
  getTitleForSelectedStar = (selectedStar) => {

    if (selectedStar < 0) {
      // Need some text to fill the field so the Dialog size doesn't change
      // but make it white so it doesn't display
      return SHRUGGIE;
    } else {
      if (this.state.questionIndex === 0) {
        return this.effectiveStarTitles[selectedStar];
      } else if (this.state.questionIndex === 1) {
        return this.easyStarTitles[selectedStar];
      } else {
        Logger.error(`Invalid question index: ${this.state.questionIndex} for CSAT`);
        // Give them something
        return this.effectiveStarTitles[selectedStar];
      }
    }
  };

  handleStarHover = ($event, index) => {
    $event.preventDefault();
    this.setState({
      currentlyHoveredStar: index
    });
  };

  selectStar = ($event, index) => {
    $event.preventDefault();
    if (this.state.selectedStar < 0) {
      // Selecting for the first time
      this.setState({ selectedStar: index });
    } else {
      if (this.state.selectedStar === index) {
        // If they re-select the same star, un-select it
        this.setState({ selectedStar: -1 });
      } else {
        // Otherwise, they want to rate a new score
        this.setState({ selectedStar: index });
      }
    }
  };

  handleCsatCommentChange = ($event) => {
    this.setState({ csatComment: $event.target.value || '' });
  };

  cancelCsat = () => {
    this.trackModalClosed(true);
    this.closeDialogAfterCsatUpload(true);
  };

  submitCsat = () => {
    this.trackModalClosed(false);
    this.closeDialogAfterCsatUpload(false);
  };

  closeDialogAfterCsatUpload = (cancelled) => {
    this.setState({ spin: true }, () => {
      const { event } = this.props;
      const { csatComment, selectedStar, promptQuestion } = this.state;

      // If they didn't pick anything, score is null
      // selectedStar is 0 index, score is 1 index
      const score = selectedStar < 0 ? null : selectedStar + 1;
      eventApi.updateCsatStatus(Event.getId(event), score, cancelled, csatComment, promptQuestion)
        .then(() => {
          // Csat updated, great. Close dialog
          Logger.info('CSAT updated yay');
          this.onDialogHidden();
        })
        .catch(error => {
          // Something went wrong, oh well I guess.
          // they'll be seeing us again
          handleError(error, null);
          this.onDialogHidden();
        });
    });
  };

  trackModalClosed = (cancelled) => {
    const { event } = this.props;
    const endTime = Event.getEndTime(event);
    const now = DateTime.now();
    const minutesSinceEnd = DateTime.unixSecondsToMoment(DateTime.momentToUnixSeconds(now)).diff(endTime, 'minutes');
    const hoursSinceEnd = DateTime.unixSecondsToMoment(DateTime.momentToUnixSeconds(now)).diff(endTime, 'hours');
    const daysSinceEnd = DateTime.unixSecondsToMoment(DateTime.momentToUnixSeconds(now)).diff(endTime, 'days');

    // Same mixpanel but in React
    const { selectedStar, csatComment, promptQuestion } = this.state;

    // Fallback
    const score = selectedStar < 0 ? null : selectedStar + 1;
    CreatorReportAnalytics.csatModal(promptQuestion,
      _.isNumber(minutesSinceEnd) ? minutesSinceEnd : TrackingAnalytics.NA,
      _.isNumber(hoursSinceEnd) ? hoursSinceEnd : TrackingAnalytics.NA,
      _.isNumber(daysSinceEnd) ? daysSinceEnd : TrackingAnalytics.NA,
      (!!csatComment && csatComment.trim().length > 0),
      (!score ? 'none' : score.toString()),
      cancelled, Event.getId(event),
      Event.getEndTime(event).toISOString());
  };

  shouldHighlightStar = (index) => {
    const { selectedStar, currentlyHoveredStar } = this.state;
    if (selectedStar < 0) {
      if (currentlyHoveredStar < 0) {
        return false;
      } else {
        return index <= currentlyHoveredStar;
      }
    } else {
      return (index <= selectedStar || index <= currentlyHoveredStar);
    }
  };

  renderNeedsToAnswerCsat = () => {
    const starList = [1, 2, 3, 4, 5];
    const { promptQuestion, selectedStar, currentlyHoveredStar, csatComment } = this.state;
    const currentStar = selectedStar < 0 ? currentlyHoveredStar : selectedStar;
    return (
      <div className="row no-gutters csat-modal">
        <div className="col">
          <div className="col justify-content-center align-items-center w-100 d-flex mb-3">
            { promptQuestion }
          </div>

          <div className="col justify-content-center align-items-center w-100 d-flex mt-3">
            { starList.map((star, index) => {
              return (
                <i
                  key={ index }
                  onMouseEnter={ $e => this.handleStarHover($e, index) }
                  onMouseLeave={ $e => this.handleStarHover($e, -1) }
                  onClick={ $e => this.selectStar($e, index) }
                  className={ `material-icons csat-star${this.shouldHighlightStar(index)
                    ? '-highlighted'
                    : ''}` }>
                  star
                </i>
              );
            }) }
          </div>
          <div
            className="mt-3 col justify-content-center align-items-center w-100 d-flex"
            style={ {
              color: currentStar < 0 ? '#FFFFFF' : '#000000'
            } }>
            { this.getTitleForSelectedStar(currentStar) }
          </div>

          <div className="col w-100 d-flex mt-3">
            <textarea
              className="col-12 pop-input pop-form-control mb-3 csat-comment"
              placeholder="Please let us know more"
              maxLength={ 500 }
              value={ csatComment }
              onChange={ this.handleCsatCommentChange } />
          </div>
        </div>
      </div>
    );
  };

  render () {
    return (
      <BaseDialog
        show={ true }
        closeOnClickOutside={ false }
        closeOnEscape={ false }
        body={ this.renderNeedsToAnswerCsat() }
        cancel="Cancel"
        onCancel={ () => {
          this.cancelCsat();
          return true;
        } }
        ok="Submit"
        onOk={ () => {
          const { selectedStar } = this.state;
          if (selectedStar >= 0) {
            this.submitCsat();
          }
          return true;
        } }
        hideDialog={ this.onDialogHidden }
      />
    );
  }

}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user
  };
};

export default connect(mapStateToProps, {
  showDialog
})(CsatModal);
